import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPinFlag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPinFlag"><Path d="M12 17.25V2.75L18 6.25L12 9.75M9 13.9512C5.36386 14.4563 2.75 15.8542 2.75 17.4995C2.75 19.5706 6.89137 21.2495 12 21.2495C17.1086 21.2495 21.25 19.5706 21.25 17.4995C21.25 15.8542 18.6361 14.4563 15 13.9512" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconPinFlag;
